module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slideAppTop"
  }, [_c('div', {
    staticClass: "slideContainer"
  }, [_c('div', {
    staticClass: "slideShow"
  }, [_c('carousel', {
    attrs: {
      "presentation": _vm.presentation,
      "progressiveReveal": _vm.progressiveReveal,
      "slideList": _vm.slideList,
      "syncSlideNum": _vm.syncSlideNum,
      "syncSlide": _vm.syncSlide
    },
    on: {
      "calculatedSlide": function($event) {
        _vm.slideCalculated($event)
      },
      "syncSlideEvent": function($event) {
        _vm.changeSyncSlide($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slideMenu"
  }, [_c('div', {
    staticClass: "slideLeftMenu"
  }, [_c('div', {
    staticClass: "slideNumber"
  }, [_vm._v(_vm._s(_vm.$t('str.Of', {
    current: _vm.currentSlide + 1,
    count: _vm.slideList.length
  })))]), _vm._v(" "), (!_vm.syncSlide) ? _c('div', {
    staticClass: "syncSlides",
    on: {
      "click": function($event) {
        _vm.changeSyncSlide(true)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/refresh.svg")
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slideRightMenu"
  }, [_c('div', {
    staticClass: "likeButton",
    on: {
      "click": _vm.likeSlide
    }
  }, [(_vm.slideLiked) ? _c('img', {
    attrs: {
      "src": require("../assets/icons/like-red.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icons/like.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twitterButton",
    on: {
      "click": _vm.openTweetUI
    }
  }, [(!_vm.slideTweeted) ? _c('img', {
    attrs: {
      "src": require("../assets/icons/twitter-bird-only.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icons/twitter-bird-only-red.svg")
    }
  })]), _vm._v(" "), _c('div', {
    ref: "shareBtn",
    staticClass: "shareButton",
    on: {
      "click": function($event) {
        _vm.toggleShareOptions($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/share.svg")
    }
  })])])])]), _vm._v(" "), (_vm.tweet) ? _c('tweetslideui', {
    attrs: {
      "twitterProfile": _vm.twitterProfile,
      "currentSlide": _vm.currentSlide,
      "slideList": _vm.slideList,
      "user": _vm.user,
      "socialMedia": _vm.socialMedia
    },
    on: {
      "closeTweetUI": _vm.toggleTweetIcon
    }
  }) : _vm._e(), _vm._v(" "), (!!_vm.anchorOptions) ? _c('shareoptions', {
    attrs: {
      "slideList": _vm.slideList,
      "currentSlide": _vm.currentSlide,
      "presentation": _vm.presentation,
      "anchor": _vm.anchorOptions
    },
    on: {
      "close": _vm.closeShare
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4b64228","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VisualPanel.vue
// module id = 487
// module chunks = 0